<template>
  <container>
    <div class="divider-md"></div>

    <grid :rwd="{ tablet: 'stack', compact: 'stack' }">
      <grid-item grow="1"> <DevHubBlog v-if="categoriesLoaded" /> </grid-item>
      <grid-item size="3/12" :rwd="{ tablet: '12/12', compact: '12/12' }">
        <div class="show-on-lg dev-hub__separator-blog"></div>
        <grid direction="stack">
          <grid-item>
            <DevHubSearch />

            <div class="dev-hub__separator-blog"></div>

            <div class="dev-hub__separator-blog"></div>

            <a
              href="https://feedback.bistudio.com/project/view/2/"
              target="_blank"
              class="butn--report"
            >
              <span> <i class="iconmoon-warning" /> report bugs </span>
            </a>

            <div class="dev-hub__separator-blog"></div>
          </grid-item>
          <grid-item>
            <h4 class="dev-hub__header-with-separator">TAGS / MOST POPULAR</h4>

            <TagCloud />

            <div class="dev-hub__separator-blog"></div>

            <h4 class="dev-hub__header-with-separator">Follow us</h4>

            <FollowButtons />
          </grid-item>
        </grid>
      </grid-item>
    </grid>
  </container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import DevHubBlog from "../components/Devhub/DevHubBlog.vue";
import DevHubSearch from "../components/Devhub/DevHubSearch.vue";
import TagCloud from "../components/common/TagCloud.vue";
import FollowButtons from "../components/common/FollowButtons.vue";
import DevHubForum from "../components/Devhub/DevHubForum.vue";
import DevhubDevelopers from "../components/Devhub/DevhubDevelopers.vue";

export default {
  components: {
    DevHubBlog,
    DevHubSearch,
    TagCloud,
    FollowButtons,
    DevHubForum,
    DevhubDevelopers
  },
  data() {
    return {
      activeBranch: 0,
      updates: null,
      tags: [],
      developers: []
    };
  },
  computed: {
    ...mapGetters("settings", {
      isMobile: "isMobile"
    }),
    ...mapGetters("categories", {
      categoriesLoaded: "getLoaded"
    }),
    ...mapGetters("tags", {
      tagsLoaded: "getLoaded"
    })
  },
  metaInfo: {
    title: "Dev-Hub"
  },
  methods: {
    ...mapActions({
      getAuthors: "authors/getList"
    }),
    ...mapActions("tags", {
      getTags: "getTags"
    }),
    ...mapActions("categories", {
      getCategories: "getCategories"
    })
  },
  async created() {
    await this.getTags();
    await this.getCategories();
  }
};
</script>
